var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"rate-history-row rate-history-row-qc"},[_vm._t("prepend-cells"),_vm._v(" "),_c('td',{attrs:{"colspan":"16"}},[_vm._v("\n        QC'd by "+_vm._s(_vm.qcUser.first_name)+" "+_vm._s(_vm.qcUser.last_name)+" (user id "+_vm._s(_vm.qcUser.id)+") on "+_vm._s(_vm.qcReadableTime)+"\n    ")]),_vm._v(" "),_vm._t("append-cells")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }